import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  background: #f0f0f5 !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-weight: 500;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 60px;
    font-weight: 500;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}
`;

export const Text = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 24px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.48px;
  `}
`;

export const CardContainerDesktop = styled.div`
  display: none;
  width: 100%;
  gap: 20px;
  margin: 50px 0px 0px;

  ${media.xl`
    display: flex;
  `}
`;

export const ContentContainerDesktop = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(20% - 16px);
  flex: 1;
  height: auto;
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  height: 100%;
  padding: 16px;
  border-radius: 20px;
`;

export const CardImageWrapper = styled.div`
  width: 40px;
  height: 40px;

  ${media.md`
    width: 48px;
    height: 48px;
  `}

  ${media.xl`
    width: 60px;
    height: 60px;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CardTitle = styled.h3`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 85%;
  letter-spacing: -0.46px;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    margin: 25px 0px 0px;
  `}
`;

export const CardText = styled.p`
  color: #6b6d7b;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.28px;
  margin: 10px 0px 0px;
`;

export const CardContainerTablet = styled.div`
  display: none;
  width: 100%;
  gap: 20px;
  margin: 40px 0px 0px;

  ${media.md`
    display: flex;
    flex-direction: column;
  `}

  ${media.xl`
    display: none;
  `}
`;

export const CardWrapperTablet = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
`;

export const ContentContainerTabletFirstRow = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(33.33% - 13.33px);
  flex: 1;
  height: auto;
`;

export const ContentContainerTabletSecondRow = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - 10px);
  flex: 1;
  height: auto;
`;

export const CardContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  margin: 24px 0px 0px;

  ${media.md`
    display: none;
  `}
`;

export const ContentContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  height: auto;
`;

export const ContentWrapperMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
